import { Provider } from '@angular/core';
import { APP_LOAD } from '@core/contracts/app-load';
import { TermsModalService } from '@b2b/features/misc/terms-modal/terms-modal.service';

export const termsModalProviders: Provider[] = [
  {
    provide: APP_LOAD,
    useClass: TermsModalService,
    multi: true,
  },
];
